import { createContext, useContext } from "react";

/** Ações do chrome administrativo, para a toolbar e a paleta falarem com o shell. */

export interface AdminChromeValue {
  openPalette: () => void;
  openHelp: () => void;
  signOut: () => Promise<void>;
}

const AdminChromeContext = createContext<AdminChromeValue | null>(null);

export const AdminChromeProvider = AdminChromeContext.Provider;

export function useAdminChrome(): AdminChromeValue {
  const value = useContext(AdminChromeContext);
  if (value === null) {
    throw new Error("useAdminChrome precisa do AdminShell");
  }
  return value;
}

export function useAdminChromeOptional(): AdminChromeValue | null {
  return useContext(AdminChromeContext);
}
